<template>
    <div class="row">
        <div class="col">
            <div class="progress mt-2">
                <div
                    class="progress-bar bg-warning"
                    role="progressbar"
                    :style="`width: ${profileCompletion}%`"
                    :aria-valuenow="profileCompletion"
                    aria-valuemin="0"
                    aria-valuemax="100"
                ></div>
            </div>
            <div class="welcome mt-2">
                <h5 class="text-uppercase font-weight-bold">
                    Welcome back {{ user.hasOwnProperty("first_name") ? user.first_name : "" }}
                </h5>
                <p class="logged font-italic">
                    last logged
                    {{
                        user.hasOwnProperty("name")
                            ? moment(user.last_login_at).format("MM/DD/YYYY")
                            : ""
                    }}
                </p>
            </div>
            <div class="message mt-2">
                {{ message }}
            </div>
            <div v-if="toDo && toDo.length" class="mt-2">
                <b>To do list:</b>
                <ul>
                    <li v-for="t in toDo">{{ t }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "WelcomeProgressWidget",
    props: ["user", "profileCompletion", "toDo"],
    computed: {
        message() {
            if (!isNaN(this.profileCompletion)) {
                switch (this.profileCompletion) {
                    case 100:
                        return `Congratulations, your profile is ${
                            this.profileCompletion
                        }% complete!`;
                    default:
                        return `You have completed ${this.profileCompletion}% of your profile.
                                Therapists can gain more benefits from
                                our software once their profile is fully
                                completed. Finish yours now!`;
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.welcome > .logged {
    color: #787878;
}
</style>
